/* eslint-disable max-len */
import { TextInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';

const TeamMemberPhoneInput = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const { phone } = values;

    if (!phone) {
        return null;
    }

    return (
        <TextInput
            id="phone-input-in-team-member"
            label={intl.formatMessage(sharedMessages.phoneNumber)}
            value={phone}
            disabled
        />
    );
};

export default TeamMemberPhoneInput;
